export const propertyWindowPassKey = 'property-pass-data';
export const liveAreaWindowPassKey = 'live-area-pass-data';
